import { render } from "./Loader.vue?vue&type=template&id=21a555fa&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=21a555fa&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a555fa"]])

export default __exports__